import Api from '../utils/api'

export const downloadPoints = async (coordinates, type) => {
  try {
    const stringifiedInsideCoordinates = coordinates[0].map((c) => [
      `${c[0]} ${c[1]}`,
    ])
    const strCoordinates = [].concat(...stringifiedInsideCoordinates).toString()
    console.log(coordinates, type)
    const response = await Api.get(
      'points',
      { coordinates: strCoordinates, file: 'geojson', type: type },
      {
        authorization: localStorage.getItem('token'),
      },
      'blob',
    )
    return response.data
  } catch (error) {
    return error.response
  }
}
